// src/auth/RequireTimker2Auth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getTimker2Session } from "./timker2Session";

/** Guard tunggal untuk seluruh halaman internal SI ALBA/TIMKER 2. */
export default function RequireTimker2Auth({ children }) {
  const location = useLocation();
  const { token } = getTimker2Session();

  if (!token) {
    return (
      <Navigate
        to="/timker2/login"
        replace
        state={{ from: location, reason: "timker2-auth" }}
      />
    );
  }

  return children;
}
